import React, { Component } from "react";
import BusDetails from "../components/Buses/BusDetails";
import ConnectivityDonut from "../components/Buses/ConnectivityDonut";
import "../css/buses.css";

var api = require("../../utils/api");
var exportPdf = require("../../utils/exportPdf");
var refreshInterval;

const BUS_TYPE = "bus";
const GROUP_COLORS = ["#dc2626", "#16a34a", "#ca8a04", "#2563eb", "#9333ea", "#ea580c", "#0891b2"];
const REFRESH_MS = 3000;

function pad(value) {
  return String(value).padStart(2, "0");
}

class Buses extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      devices: [],
      groups: [],
      expandedGroups: {},
      selectedBusId: null,
      search: "",
      exporting: false,
      alarmBus: null
    };
    /* the export captures this node, everything outside it stays out of the file */
    this.mainRef = React.createRef();
  }

  componentDidMount() {
    this.busesEvent({ name: "getInfo" });
    refreshInterval = setInterval(this.busesEvent, REFRESH_MS, { name: "getInfo" });
  }

  componentWillUnmount() {
    this.unmounted = true;
    clearInterval(refreshInterval);
  }

  busesEvent = event => {
    const { sessionId, setCookie } = this.props;

    if (event.name === "getInfo") {
      if (sessionId === "" || sessionId == null) {
        setCookie("");
        return;
      }
      api.getSessionInfo(sessionId).then(
        function (data) {
          if (data.data.error === "Logged out") {
            clearInterval(refreshInterval);
            setCookie("");
            return;
          }
          this.setState({
            devices: data.data.devices,
            groups: data.data.groups,
            loaded: true
          });
        }.bind(this)
      );
    }
  };

  /* Builds the one level tree: every group holding buses, plus the ungrouped ones */
  getBusGroups() {
    const { devices, groups } = this.state;
    const buses = devices.filter(dev => dev.type === BUS_TYPE);
    var tree = [];

    for (let i = 0; i < groups.length; i++) {
      const gr = groups[i];
      const groupBuses = buses.filter(bus => gr.devices.indexOf(bus._id) > -1);
      if (groupBuses.length > 0) {
        tree.push({
          _id: gr._id,
          name: gr.name,
          color: GROUP_COLORS[tree.length % GROUP_COLORS.length],
          buses: groupBuses
        });
      }
    }

    const ungrouped = buses.filter(
      bus => !groups.some(gr => gr.devices.indexOf(bus._id) > -1)
    );
    if (ungrouped.length > 0) {
      tree.push({
        _id: "nogroup",
        name: "Sin grupo",
        color: GROUP_COLORS[tree.length % GROUP_COLORS.length],
        buses: ungrouped
      });
    }

    return tree;
  }

  matchesSearch(bus) {
    const search = this.state.search.toLowerCase().trim();
    if (!search) return true;
    return (
      (bus.name || "").toLowerCase().indexOf(search) > -1 ||
      (bus.deviceId || "").toLowerCase().indexOf(search) > -1
    );
  }

  groupClicked = groupId => {
    const { expandedGroups } = this.state;
    this.setState({
      expandedGroups: Object.assign({}, expandedGroups, { [groupId]: !expandedGroups[groupId] })
    });
  };

  busClicked = busId => {
    this.setState({ selectedBusId: busId });
  };

  alarmClicked = (event, bus) => {
    /* the icon sits inside the leaf, keep the click from selecting the bus */
    event.stopPropagation();
    this.setState({ alarmBus: bus });
  };

  alarmCancelled = () => {
    this.setState({ alarmBus: null });
  };

  alarmConfirmed = () => {
    const { alarmBus } = this.state;
    const { sessionId } = this.props;
    this.setState({ alarmBus: null });

    api.controlDevice(sessionId, { buttonTriggered: false }, alarmBus._id).then(
      function (data) {
        if (data.data.error) {
          window.alert("No se pudo marcar la alarma como recibida");
          return;
        }
        this.busesEvent({ name: "getInfo" });
      }.bind(this)
    );
  };

  searchChanged = value => {
    this.setState({ search: value });
  };

  /* dd/mm/yyyy hh:mm for the stamp inside the file, yyyy-mm-dd_hhmm for its name */
  static stamp(date, forFilename) {
    const day = pad(date.getDate());
    const month = pad(date.getMonth() + 1);
    const time = pad(date.getHours()) + (forFilename ? "" : ":") + pad(date.getMinutes());
    if (forFilename) return date.getFullYear() + "-" + month + "-" + day + "_" + time;
    return day + "/" + month + "/" + date.getFullYear() + " " + time;
  }

  exportClicked = () => {
    const now = new Date();
    /* the 3 s poll would re-render the page in the middle of the capture */
    clearInterval(refreshInterval);
    this.setState({ exporting: true });

    exportPdf.exportElementToPdf(this.mainRef.current, {
      filename: "parque-buses_" + Buses.stamp(now, true) + ".pdf",
      onClone: function (cloned) {
        /* the file says when it was taken, the live page stays as it is */
        const sub = cloned.querySelector(".buses-main-header .sub");
        if (!sub) return;
        const stamp = cloned.ownerDocument.createElement("div");
        stamp.className = "sub";
        stamp.textContent = "Generado: " + Buses.stamp(now, false);
        sub.parentNode.insertBefore(stamp, sub.nextSibling);
      }
    }).catch(function (error) {
      console.error("PDF export failed", error);
      window.alert("No se pudo generar el PDF");
    }).then(() => {
      if (this.unmounted) return;
      this.setState({ exporting: false });
      refreshInterval = setInterval(this.busesEvent, REFRESH_MS, { name: "getInfo" });
    });
  };

  render() {
    const { loaded, exporting } = this.state;
    const busGroups = this.getBusGroups();
    const allBuses = busGroups.reduce((acc, gr) => acc.concat(gr.buses), []);

    return (
      <div className="buses-page">
        {this.renderSidebar(busGroups, allBuses)}
        <div className="buses-main" ref={this.mainRef}>
          <div className="buses-main-header">
            <div className="buses-main-header-text">
              <h1>Monitor de Conectividad — Parque de Buses</h1>
              <div className="sub">Estado de reporte en tiempo real del parque de buses</div>
            </div>
            <button
              className="buses-export-btn"
              type="button"
              data-export-hide
              disabled={!loaded || exporting}
              onClick={this.exportClicked}
            >
              {exporting ? "Generando..." : "Exportar PDF"}
            </button>
          </div>
          {loaded ? this.renderStats(allBuses) : <div className="buses-loading">Cargando...</div>}
          {loaded ? this.renderDetail(busGroups) : null}
        </div>
        {this.renderAlarmDialog()}
      </div>
    );
  }

  renderAlarmDialog() {
    const { alarmBus } = this.state;
    if (!alarmBus) return null;

    return (
      <div className="buses-dialog-backdrop" onClick={this.alarmCancelled}>
        <div className="buses-dialog" onClick={event => event.stopPropagation()}>
          <div className="buses-dialog-title">Marcar alarma recibida?</div>
          <div className="buses-dialog-sub">{alarmBus.name} - {alarmBus.patente}</div>
          <div className="buses-dialog-actions">
            <button type="button" className="buses-dialog-btn cancel" onClick={this.alarmCancelled}>Cancel</button>
            <button type="button" className="buses-dialog-btn confirm" onClick={this.alarmConfirmed}>Si</button>
          </div>
        </div>
      </div>
    );
  }

  renderSidebar(busGroups, allBuses) {
    const { search, loaded } = this.state;
    const online = allBuses.filter(bus => bus.connected).length;
    const offline = allBuses.length - online;

    return (
      <div className="buses-sidebar">
        <div className="buses-sidebar-header">
          <div className="logo">Connecta</div>
          <h2>Parque de Buses</h2>
          <div className="count">
            {loaded
              ? allBuses.length + " buses — " + online + " reportados, " + offline + " caídos"
              : "Cargando..."}
          </div>
        </div>

        <div className="buses-legend">
          <span><span className="buses-legend-dot green"></span> Totalidad reportada</span>
          <span><span className="buses-legend-dot red"></span> Falla en grupo</span>
        </div>

        <div className="buses-search">
          <input
            type="text"
            value={search}
            placeholder="Buscar bus..."
            onChange={event => this.searchChanged(event.target.value)}
          />
        </div>

        <div className="buses-tree">
          {busGroups.length === 0 && loaded ? (
            <div className="buses-tree-empty">No hay buses disponibles</div>
          ) : null}
          {busGroups.map(group => this.renderGroup(group))}
        </div>
      </div>
    );
  }

  renderGroup(group) {
    const { expandedGroups, search } = this.state;
    const visibleBuses = group.buses.filter(bus => this.matchesSearch(bus));
    if (visibleBuses.length === 0) return null;

    /* While searching every matching group stays open so the results are visible */
    const expanded = search.trim() ? true : expandedGroups[group._id] === true;
    const total = group.buses.length;
    const online = group.buses.filter(bus => bus.connected).length;
    const offline = total - online;

    var badgeClass = "buses-tree-badge";
    if (offline > 0) badgeClass += " warn";
    else badgeClass += " ok";

    return (
      <div className="buses-tree-group" key={group._id}>
        <div
          className="buses-tree-node"
          style={{ borderLeft: "3px solid " + group.color }}
          onClick={() => this.groupClicked(group._id)}
        >
          <span className={expanded ? "buses-tree-arrow expanded" : "buses-tree-arrow"}>&#9654;</span>
          <span className={offline > 0 ? "buses-tree-dot offline" : "buses-tree-dot online"}></span>
          <span className="buses-tree-label">{group.name}</span>
          <span className={badgeClass}>
            {total + " buses" + (offline > 0 ? " / " + offline + " caídos" : "")}
          </span>
        </div>
        {expanded ? (
          <div className="buses-tree-children">
            {visibleBuses.map(bus => this.renderBus(bus))}
          </div>
        ) : null}
      </div>
    );
  }

  renderBus(bus) {
    const { selectedBusId } = this.state;

    return (
      <div
        className={selectedBusId === bus._id ? "buses-tree-leaf selected" : "buses-tree-leaf"}
        key={bus._id}
        onClick={() => this.busClicked(bus._id)}
      >
        <span className={bus.connected ? "buses-tree-leaf-dot online" : "buses-tree-leaf-dot offline"}></span>
        <span className="buses-tree-leaf-name">{bus.name} - {bus.patente}</span>
        {bus.buttonTriggered === true ? (
          <img
            className="buses-tree-leaf-alarm"
            src="/img/icons/alarm.svg"
            alt="Alarma"
            title="Alarma de botón"
            onClick={event => this.alarmClicked(event, bus)}
          />
        ) : null}
        <span className="buses-tree-leaf-id">{bus.deviceId}</span>
      </div>
    );
  }

  renderStats(allBuses) {
    const total = allBuses.length;
    const online = allBuses.filter(bus => bus.connected).length;
    const offline = total - online;
    const pct = total > 0 ? (online / total * 100).toFixed(1) : "0.0";

    return (
      <div className="buses-stats-row">
        <div className="buses-stat-card total">
          <div className="stat-value">{total.toLocaleString()}</div>
          <div className="stat-label">Total Buses</div>
        </div>
        <div className="buses-stat-card online">
          <div className="stat-value">{online.toLocaleString()}</div>
          <div className="stat-label">Reportados</div>
        </div>
        <div className="buses-stat-card offline">
          <div className="stat-value">{offline.toLocaleString()}</div>
          <div className="stat-label">No Reportados</div>
        </div>
        <div className="buses-stat-card pct">
          <div className="stat-value">{pct}%</div>
          <div className="stat-label">Conectividad</div>
        </div>
        <ConnectivityDonut online={online} offline={offline} pct={pct} />
      </div>
    );
  }

  renderDetail(busGroups) {
    const { selectedBusId } = this.state;
    const { sessionId } = this.props;
    var selectedBus = null;
    var selectedGroup = null;

    for (let i = 0; i < busGroups.length; i++) {
      const bus = busGroups[i].buses.filter(b => b._id === selectedBusId)[0];
      if (bus) {
        selectedBus = bus;
        selectedGroup = busGroups[i];
        break;
      }
    }

    return (
      <div className="buses-detail-area">
        {selectedBus ? (
          <BusDetails device={selectedBus} groupName={selectedGroup.name} sessionId={sessionId} />
        ) : (
          <div className="buses-detail-panel">
            <span className="buses-detail-empty">Selecciona un bus en el panel izquierdo para ver sus detalles</span>
          </div>
        )}
      </div>
    );
  }
}

export default Buses;
